import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as validate from './FormValidation';
import {scrollToFirstError} from '../helpers/ReduxFormScrollToError';
import { Button, Icon, Divider, Alert } from 'antd';





const FormGrundEig = props => {
    const { handleSubmit, pristine, reset, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="content">
                <Divider orientation={"left"}>Angaben Grundstückseigentümer / -in</Divider>

                <Field
                    name="Grund_Name"
                    label="Name:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}

                />

                <Field
                    name="Grund_Vorname"
                    label="Vorname:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />
                <Field
                    name="Grund_Firma"
                    label="Firma:"
                    type="text"
                    component={validate.renderField}
                    
                />
                <Field
                    name="Grund_FirmaGesetzl"
                    label="Gesetzlicher Vertreter der Firma:"
                    type="text"
                    component={validate.renderField}

                />
                <Field
                    name="Grund_Strasse"
                    label="Straße & Hausnummer:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />
                <Field
                    name="Grund_PLZ"
                    label="PLZ:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.number]}
                />
                <Field
                    name="Grund_Ort"
                    label="Ort:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />
                <Field
                    name="Grund_Tel_Priv"
                    label="Tel. Privat:"
                    type="text"
                    component={validate.renderField}
                    
                />
                <Field
                    name="Grund_Tel_Arbeit"
                    label="Tel. Arbeit:"
                    type="text"
                    component={validate.renderField}
                    
                />
                <Field
                    name="Grund_Mail"
                    label="E-Mail (Bitte eintragen, wenn Sie eine Bestätigungsnachricht per Email wünschen. Die Angabe ist nicht verpflichtend):"
                    type="text"
                    component={validate.renderField}
                    validate={[validate.email]}
                    
                />
                <Field
                    name="Grund_Fax"
                    label="FAX:" type="text"
                    component={validate.renderField}
                    
                />
                <Field
                    name="Grund_Tel_Mobil"
                    label="Tel. Mobil:"
                    type="text"
                    component={validate.renderField}
                />

                <Alert
                    message="Information"
                    description="
                        Als Material für die Trinkwasserinstallation ist KUNSTSTOFF ODER EDELSTAHL zu verwenden (kein verzinkter Stahl).
                        Schützen Sie Ihre Wasserinstallation sowie Bauwasserhähne vor Frost, Diebstahl und Zerstörung!
                        "
                    type="warning"
                    showIcon
                />

                <div className={"right-container"}>
                    <Button className={"pull-right"} type={"primary"} htmlType={"submit"} disabled={submitting}>Weiter <Icon type={"right"}/></Button>
                </div>
            </div>
        </form>
    );
};



let FormGrundEigRedux = reduxForm({
    form: 'auftragform',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(FormGrundEig);



export default FormGrundEigRedux;



// WEBPACK FOOTER //
// ./src/components/FormGrundEig.js